import React from 'react';
import { motion } from 'framer-motion';
import { Star, MessageCircle } from 'lucide-react';
const testimonials = [{
  initial: 'S',
  color: 'bg-pink-100 text-pink-700',
  name: 'S. M.',
  location: 'Psicóloga Clínica, Buenos Aires',
  text: 'Antes me pasaba los domingos organizando fichas y redactando mensajes. Ahora abro el PDF, busco lo que necesito y en 5 minutos está resuelto.'
}, {
  initial: 'L',
  color: 'bg-blue-100 text-blue-700',
  name: 'L. R.',
  location: 'Psicólogo, Córdoba',
  text: 'Los modelos de informes solos ya valieron todo. Antes me llevaba dos horas una derivación. Ahora tengo la estructura lista y en 20 minutos está hecho.'
}, {
  initial: 'V',
  color: 'bg-emerald-100 text-emerald-700',
  name: 'V. T.',
  location: 'Psicóloga, Rosario',
  text: 'La biblioteca de respuestas me cambió la rutina. Tenía pacientes que escribían a cualquier hora y no sabía cómo poner límites. Ahora tengo los mensajes listos.'
}, {
  initial: 'M',
  color: 'bg-amber-100 text-amber-700',
  name: 'M. B.',
  location: 'Psicólogo Autónomo, Mendoza',
  text: 'Comunicar un aumento siempre me generaba incomodidad. Con los scripts lo hice en dos líneas, claro y sin drama.'
}];
export function TestimonialsBottom() {
  return <section className="py-12 md:py-16 bg-transparent pt-[30px] pb-[30px]" data-id="element-194">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-195">
        <div className="text-center mb-12 flex flex-col items-center" data-id="element-196">
          <MessageCircle className="w-10 h-10 text-[#d4a017] mb-4" data-id="element-197" />
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-[#2f3a2c]" data-id="element-198">
            Lo que otros psicólogos están diciendo
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-199">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200 flex flex-col h-full" data-id="element-200">
              <div className="flex text-[#d4a017] mb-4" data-id="element-201">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-202" />)}
              </div>

              <p className="text-slate-700 text-lg leading-relaxed mb-6 italic flex-grow" data-id="element-203">
                "{t.text}"
              </p>

              <div className="flex items-center border-t border-slate-100 pt-4 mt-auto" data-id="element-204">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold ${t.color} mr-3 flex-shrink-0`} data-id="element-205">
                  {t.initial}
                </div>
                <div data-id="element-206">
                  <div className="font-bold text-[#2f3a2c] text-sm" data-id="element-207">
                    {t.name}
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-208">{t.location}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}